import { Text, View } from 'react-native'

interface PinCardProps {
  pin: string
}

export function PinCard({ pin }: PinCardProps) {
  return (
    <View className="items-center rounded-lg border border-border bg-canvas-primary p-6">
      <Text className="text-center text-6xl font-bold tracking-widest text-accent">
        {pin}
      </Text>
    </View>
  )
}